import PlanPhoto from './PlanPhoto';
import Badge from '../ui/Badge';
import { formatCurrency, formatDuration } from '../../lib/formatPlan';

/**
 * Catalog card — shared by the investor browsing screen and the admin
 * management screen (GET /investor/investment-plans is the same for both;
 * only the mutation affordances in the detail view differ by permission).
 */
export default function PlanCard({ plan, onView }) {
  return (
    <button
      type="button"
      onClick={() => onView(plan)}
      className="glass-card glass-card-hover p-4 text-left flex flex-col gap-3"
    >
      <PlanPhoto src={plan.photo_url} alt={plan.name} className="h-32 w-full rounded-lg" />

      <div>
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-sm font-semibold text-foreground leading-snug">{plan.name}</h3>
          <Badge tone="success" className="shrink-0">
            {plan.roi_percentage}% ROI
          </Badge>
        </div>
        {plan.description && <p className="text-xs text-foreground-muted mt-1 line-clamp-2">{plan.description}</p>}
      </div>

      <dl className="grid grid-cols-2 gap-2 text-xs text-foreground-subtle mt-auto pt-2 border-t border-border">
        <div>
          <dt>Range</dt>
          <dd className="text-foreground text-sm font-medium">
            {formatCurrency(plan.minimum_amount)}
            {plan.maximum_amount != null ? ` – ${formatCurrency(plan.maximum_amount)}` : '+'}
          </dd>
        </div>
        <div>
          <dt>Duration</dt>
          <dd className="text-foreground text-sm font-medium">{formatDuration(plan.duration_in_days)}</dd>
        </div>
        {plan.payout_frequency_label && (
          <div className="col-span-2">
            <dt>Payout</dt>
            <dd className="text-foreground text-sm font-medium">Paid {plan.payout_frequency_label}</dd>
          </div>
        )}
      </dl>
    </button>
  );
}
